/*--------------------
* Philosophy Section
----------------------*/
const PRINCIPLES = [
  {
    num: "01",
    title: "Build what we'd use",
    text: "Every venture starts as a real itch. If we wouldn't open the app ourselves next week, it doesn't get built.",
  },
  {
    num: "02",
    title: "Ship small, learn fast",
    text: "Ideas are cheap — feedback is gold. We launch early, listen hard, and iterate in public instead of polishing in the dark.",
  },
  {
    num: "03",
    title: "Stay weird",
    text: "The best products come from odd angles. We chase the ideas that make us grin, not just the ones that fit a pitch deck.",
  },
];

export default function Philosophy() {
  return (
    <section id="philosophy" className="section bg-night-900">
      <div className="container">
        <div className="section-heading text-center">
          <p className="eyebrow">02 — How we work</p>
          <h2>Our philosophy</h2>
        </div>
        <div className="grid md:grid-cols-3 grid-cols-1 gap-6">
          {PRINCIPLES.map((p) => (
            <div key={p.num} className="glass-card p-8">
              <span className="font-mono text-[13px] text-ember-400 tracking-[2px]">
                {`// ${p.num}`}
              </span>
              <h4 className="text-[22px] md:text-[24px] font-[600] mt-4 mb-3">
                {p.title}
              </h4>
              <p className="text-[15px] md:text-[16px] leading-relaxed">
                {p.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
